module.exports = __webpack_public_path__ + "enterprise-done-right.1e59X7Aq.jpg";